import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";

import Layout from "app/components/layouts";
import PartOne from "app/components/joint/personalDetails/PartOne";
import PartTwo from "app/components/joint/personalDetails/PartTwo";
import PartThree from "app/components/joint/personalDetails/PartThree";
import PartFour from "app/components/joint/personalDetails/PartFour";
import PartFive from "app/components/joint/personalDetails/PartFive";
import { StepsComponent } from "app/utils/types";
import JointStepper from "app/components/common/JointStepper";

const JointPersonalDetails: React.FC = () => {
  const currentStep = useSelector(
    (state: RootState) => state.jointpersonalDetails.currentStep
  );

  const steps = useMemo<StepsComponent[]>(
    () => [
      <PartOne key="personal-details-setpone" />,
      <PartTwo key="personal-details-setptwo" />,
      <PartThree key="personal-Details-setp-three" />,
      <PartFour key="personal-details-setp-four" />,
      <PartFive key="personal-details-setp-five" />,
    ],
    []
  );

  const renderStep = useMemo(() => {
    if (currentStep >= 0 && currentStep < steps.length) {
      return steps[currentStep];
    }
    return <PartOne />;
  }, [currentStep, steps]);
  return (
    <>
      <Layout>
        <JointStepper />
        {renderStep}
      </Layout>
    </>
  );
};

export default JointPersonalDetails;
